import React, { useEffect, useState, useContext } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import FormControl from "@mui/material/FormControl";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { MyDomain } from "../App";
import axios from "axios";
import { useHistory } from "react-router-dom";
import dayjs from "dayjs";
import { Autocomplete, Paper } from "@mui/material";
import { styled } from "@mui/system";
import jwtDecode from "jwt-decode";
import { AppContext, useAppContext } from "./../AppContext";
import { useTranslation } from "react-i18next";
const StyledPaper = styled(Paper)({
  maxHeight: "380px", // Set maximum height for the dropdown
  overflowY: "auto", // Enable vertical scroll
});
const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function Register() {
  const { t, i18n } = useTranslation();
  const { setUser, setToken } = useAppContext();
  const { CartAmount, setCartAmount, WishList, setWishList } =
    useContext(AppContext);

  const [CountryPhoneNumbers, setCountryPhoneNumbers] = useState({
    label: "+972",
    value: "+972",
  });

  const [ArrayCountryPhoneNumbers, setArrayCountryPhoneNumbers] = useState([
    { label: "+972", value: "+972" },
  ]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const history = useHistory();

  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [Email, setEmail] = useState("");
  const [DateOfBirth, setDateOfBirth] = useState(null);

  const [PhoneNumber, setPhoneNumber] = useState("");
  const [PhoneNumberDataBase, setPhoneNumberDataBase] = useState("");
  const [Password, setPassword] = useState("");
  const [Password2, setPassword2] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [ReceiveNotifications, setReceiveNotifications] = useState("0");
  const [ErrorPassword, setErrorPassword] = useState(false);
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const [showPassword2, setShowPassword2] = React.useState(false);

  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);

  const handleMouseDownPassword2 = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword2 = (event) => {
    event.preventDefault();
  };
  const ReceiveNotificationsFunc = (event) => {
    setReceiveNotifications(event.target.checked ? "1" : "0");
  };

  const [FirstNameErr, setFirstNameErr] = useState(false);
  const [LastNameErr, setLastNameErr] = useState(false);
  const [EmailErr, setEmailErr] = useState(false);
  const [EmailExistErr, setEmailExistErr] = useState(false);

  const handleSubmit = async (event) => {
    let formattedDate = DateOfBirth;
    if (DateOfBirth !== null) {
      formattedDate = DateOfBirth.format("DD-MM-YYYY");
    }
    if (FirstName.length < 2) {
      setFirstNameErr(true);
    } else {
      setFirstNameErr(false);
    }
    if (LastName.length < 2) {
      setLastNameErr(true);
    } else {
      setLastNameErr(false);
    }

    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    regex.test(Email);
    if (regex.test(Email)) {
      setEmailErr(false);
    } else {
      setEmailErr(true);
    }

    if (Password !== Password2 || Password.length < 2 || Password2 < 2) {
      setErrorPassword(true);
      return;
    } else {
      setErrorPassword(false);
    }
    if (
      !regex.test(Email) ||
      Password.length < 2 ||
      LastNameErr ||
      FirstNameErr ||
      ErrorPassword
    ) {
      return;
    }
    //event.preventDefault();
    const data = {
      FirstName: FirstName,
      LastName: LastName,
      Email: Email,
      DateOfBirth: formattedDate, //DateOfBirth,
      Phonenumber: CountryPhoneNumbers?.value + " " + PhoneNumber,
      Password: Password,
      Role: "Client",
      ReceiveNotifications: {
        Email: ReceiveNotifications, // Optional: can be same as user's email or different
        Phone: ReceiveNotifications, // Optional: can be same as user's phone or different
      },
    };

    //console.log(data);
    try {
      const response = await axios.post(`${MyDomain}Users/CreateUser2`, data);
      const decodedToken = jwtDecode(response.data.token);
      setUser(decodedToken); // Store user data in context
      setToken(response.data.token); // Store token in context
      if (response.data.token) {
        // Save token and user data in localStorage
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("role", decodedToken.role);
        localStorage.setItem("user", JSON.stringify(decodedToken));
        setEmailExistErr("");
        setResponseMessage("Data submitted successfully!");
        setWishList(response.data.wishListItems);
        setCartAmount(response.data.cartItems.length);
        history.push(`/`);
        setEmail("");
        setPassword("");
      }
    } catch (error) {
      console.log(error.response?.data || error.message);
      alert(error.response?.data || error.message);
    }
    // axios
    //   .post(`${MyDomain}Users/CreateUser2`, data) // replace with your API URL
    //   .then((response) => {
    //     setResponseMessage("Data submitted successfully!");
    //     const data2 = {
    //       Id: response.data?.id,
    //       FirstName: FirstName,
    //       LastName: LastName,
    //       Email: Email,
    //       DateOfBirth: formattedDate, //DateOfBirth,
    //       Phonenumber: CountryPhoneNumbers?.value + " " + PhoneNumber,
    //       Password: Password,
    //       Role: "Client",
    //       ReceiveNotifications: {
    //         Email: ReceiveNotifications, // Optional: can be same as user's email or different
    //         Phone: ReceiveNotifications, // Optional: can be same as user's phone or different
    //       },
    //     };
    //     setEmailExistErr("");
    //     localStorage.setItem("user", JSON.stringify(data2));
    //     history.push(`/`);
    //   })
    //   .catch((err) => {
    //     setResponseMessage("Error submitting data.");
    //     console.log(err.response.data);
    //     setEmailExistErr(err.response.data);
    //   });
  };
  const prefix = "+972";

  const handlePhoneChange = (e) => {
    let inputValue = e.target.value;

    // Ensure the input starts with the prefix
    if (!inputValue.startsWith(prefix)) {
      inputValue = prefix;
    }

    // Extract the digits after the prefix
    let phoneDigits = inputValue.slice(prefix.length);

    // Remove extra spaces in case the user tries to add multiple spaces
    phoneDigits = phoneDigits.replace(/\s+/g, "");

    // Insert a space after the first two digits
    if (phoneDigits.length > 2) {
      phoneDigits = phoneDigits.slice(0, 2) + " " + phoneDigits.slice(2);
    }
    const modifiedText = prefix.replace(/[()]/g, "");
    setPhoneNumberDataBase(prefix + phoneDigits);
    setPhoneNumber(prefix + " " + phoneDigits);
  };

  const handleFocus = () => {
    if (!PhoneNumber.startsWith(prefix)) {
      setPhoneNumber(prefix);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        paddingLeft: MyWidth <= 1024 ? "2%" : "0%",
        paddingRight: MyWidth <= 1024 ? "2%" : "0%",
      }}
    >
      <div style={{ paddingTop: 50 }}>
        <p style={{ fontWeight: 500, fontSize: 22 }}>
          {t("profile.Newuserregistration")}
        </p>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: MyWidth <= 1024 ? "100%" : 500,
        }}
      >
        <div
          style={{
            paddingBottom: 25,
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <TextField
            id="standard-basic"
            label={t("profile.Firstname")}
            variant="standard"
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={FirstName} // Bind the state value to the TextField
            onChange={(e) => setFirstName(e.target.value)} // Update state on input change
          />
          {FirstNameErr ? (
            <div style={{ display: "flex", width: "90%" }}>
              <a style={{ fontSize: 14, color: "red" }}>
                Please check you first name
              </a>
            </div>
          ) : (
            <></>
          )}
        </div>

        <div
          style={{
            paddingBottom: 25,
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <TextField
            id="standard-basic"
            label={t("profile.Lastname")}
            variant="standard"
            InputLabelProps={{
              style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
            }}
            value={LastName} // Bind the state value to the TextField
            onChange={(e) => setLastName(e.target.value)} // Update state on input change
          />
          {LastNameErr ? (
            <div style={{ display: "flex", width: "90%" }}>
              <a style={{ fontSize: 14, color: "red" }}>
                Please check you last name
              </a>
            </div>
          ) : (
            <></>
          )}
        </div>

        {/* <TextField
          id="standard-basic"
          label="Date of birth"
          variant="standard"
          style={{ paddingBottom: 25 }}
          InputLabelProps={{
            style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
          }}
          value={DateOfBirth} // Bind the state value to the TextField
          onChange={(e) => setDateOfBirth(e.target.value)} // Update state on input change
        /> */}
        <div style={{ width: "100%", paddingBottom: 25 }}>
          {/* Ensures the container is 100% width */}
          <p style={{ margin: 0, fontSize: 12, opacity: 0.5 }}>
            {t("profile.Dateofbirth")}
          </p>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={DateOfBirth}
              onChange={(newValue) => setDateOfBirth(newValue)}
              slotProps={{
                textField: {
                  variant: "standard", // Removes outer border and keeps only the underline
                  InputProps: {
                    disableUnderline: false, // Ensure underline is shown
                  },
                  sx: {
                    width: "100%", // Enforces full width on the text field
                    "& .MuiInputBase-root:before": {
                      borderBottom: "1px solid rgba(0, 0, 0, 0.42)", // Regular underline color
                    },
                    "& .MuiInputBase-root:hover:not(.Mui-disabled):before": {
                      borderBottom: "1px solid black", // Underline color on hover
                    },
                    "& .MuiInputBase-root:after": {
                      borderBottom: "2px solid #1976d2 ", // Underline color when focused
                    },
                  },
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  sx={{
                    width: "100%", // Ensures TextField spans full width
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "red", // Default border color
                      },
                      "&:hover fieldset": {
                        borderColor: "red", // Hover border color
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "red", // Focus border color
                      },
                    },
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </div>
        {/* <TextField
          id="standard-basic"
          label="Phone*"
          variant="standard"
          style={{ paddingBottom: 25 }}
          InputLabelProps={{
            style: { opacity: 0.5, fontSize: "15px" },
          }}
          value={PhoneNumber}
          onChange={handlePhoneChange}
          onFocus={handleFocus}
        /> */}
        <div
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "35%",
            }}
          >
            <Autocomplete
              sx={{ width: "100%" }}
              options={ArrayCountryPhoneNumbers}
              getOptionLabel={(option) => option.label}
              value={CountryPhoneNumbers}
              onFocus={() => setIsDrawerOpen(true)} // Open drawer on focus
              onBlur={() => setIsDrawerOpen(false)} // Close drawer on blur
              onChange={(event, newValue) => setCountryPhoneNumbers(newValue)}
              PaperComponent={(props) => <StyledPaper {...props} />}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("profile.Countrynumber")}
                  variant="standard"
                  style={{
                    paddingBottom: 45,
                    width: "100%",
                    maxWidth: 500,
                  }}
                  InputLabelProps={{
                    style: { opacity: 0.5, fontSize: "15px" },
                  }}
                  //error={CityError} // Apply the error state to show red color
                />
              )}
            />
          </div>
          <div style={{ display: "flex", width: "60%" }}>
            <TextField
              id="standard-basic"
              label={t("profile.Phone")}
              variant="standard"
              style={{ paddingBottom: 45, width: "100%" }}
              InputLabelProps={{
                style: { opacity: 0.5, fontSize: "15px" },
              }}
              InputProps={{
                inputProps: {
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                  style: {
                    // Remove arrows in all browsers
                    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    MozAppearance: "textfield", // Firefox
                    appearance: "none", // Standard
                  },
                },
              }}
              value={PhoneNumber}
              onChange={(e) =>
                setPhoneNumber(e.target.value.replace(/[^0-9]/g, ""))
              } // Force numbers only
              //error={PhoneNumberError}
            />
          </div>
        </div>
        <TextField
          id="standard-basic"
          label={t("profile.email")}
          variant="standard"
          style={{}}
          InputLabelProps={{
            style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
          }}
          value={Email} // Bind the state value to the TextField
          onChange={(e) => setEmail(e.target.value)} // Update state on input change
        />
        <a style={{ fontSize: 14, color: "red" }}>{EmailExistErr}</a>
        {EmailErr ? (
          <div style={{ display: "flex", width: "90%" }}>
            <a style={{ fontSize: 14, color: "red" }}>
              Please check your email
            </a>
          </div>
        ) : (
          <></>
        )}
        <p
          style={{
            display: "flex",
            margin: 0,
            justifyContent: "flex-start",
            alignItems: "center",
            paddingTop: 10,
            paddingBottom: 50,
            fontSize: 14,
          }}
        >
          <Checkbox
            {...label}
            icon={
              <Box
                sx={{
                  width: 18,
                  height: 18,
                  border: "1.4px solid black", // border for unchecked state
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: 1,
                }}
              />
            } // Unchecked icon
            checkedIcon={
              <Box
                sx={{
                  width: 18,
                  height: 18,
                  border: "1.4px solid black", // border for checked state
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: 1,
                }}
              >
                <Box
                  sx={{
                    width: 10, // smaller square inside
                    height: 10,
                    backgroundColor: "black", // color of the small square
                  }}
                />
              </Box>
            } // Checked icon with small square
            checked={ReceiveNotifications === "1"}
            onChange={ReceiveNotificationsFunc}
            sx={{
              padding: 0, // remove padding
            }}
          />
          {t("profile.Recievenotificationsaboutnewarrivalssalesspecialoffers")}
        </p>

        <FormControl variant="standard" style={{ paddingBottom: 25 }}>
          <InputLabel
            htmlFor="standard-adornment-password"
            sx={{ opacity: 0.5, fontSize: "15px" }} // Style for the label
          >
            {t("profile.Password")}
            <span style={{ color: "red" }}>*</span>{" "}
            {/* Add asterisk to indicate required */}
          </InputLabel>
          <Input
            id="standard-adornment-password"
            type={showPassword ? "text" : "password"}
            value={Password}
            onChange={(e) => setPassword(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                >
                  {showPassword ? (
                    <VisibilityOff fontSize="small" />
                  ) : (
                    <Visibility fontSize="small" />
                  )}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <FormControl variant="standard" style={{ paddingBottom: 25 }}>
          <InputLabel
            htmlFor="standard-adornment-password"
            sx={{ opacity: 0.5, fontSize: "15px" }} // Style for the label
          >
            {t("profile.Repeatpassword")}
            <span style={{ color: "red" }}>*</span>{" "}
            {/* Add asterisk to indicate required */}
          </InputLabel>
          <Input
            id="standard-adornment-password"
            type={showPassword2 ? "text" : "password"}
            value={Password2}
            onChange={(e) => setPassword2(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword2}
                  onMouseDown={handleMouseDownPassword2}
                >
                  {showPassword2 ? (
                    <VisibilityOff fontSize="small" />
                  ) : (
                    <Visibility fontSize="small" />
                  )}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        {!ErrorPassword ? (
          <></>
        ) : (
          <>
            <p style={{ color: "red" }}>Pleas check your password !</p>
          </>
        )}

        <button
          style={{
            borderWidth: 0,
            backgroundColor: "#27272a",
            color: "white",
            marginTop: 25,
            height: 50,
          }}
          onClick={() => {
            {
              {
                handleSubmit();
              }
            }
          }}
        >
          {t("profile.Registration")}
        </button>
      </div>
    </div>
  );
}
